import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { HeaderNavPill } from "./HeaderNavPill";
import { HeaderActionsPill } from "./HeaderActionsPill";
import { MobileHeader } from "./MobileHeader";

export type NavItem = {
  label: string;
  to?: string;
  onClick?: () => void;
  /** Badge numérico (ej. cantidad en carrito de repuestos) */
  badge?: number;
};

const SCROLL_THRESHOLD = 48;

export function Header() {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const forceScrolled = location.pathname === "/sucursales";
  const lightText = location.pathname === "/" || isScrolled || forceScrolled;

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > SCROLL_THRESHOLD);
    onScroll(); // init
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems: NavItem[] = [
    { label: "Catálogo", to: "/catalogo" },
    { label: "Nosotros", to: "/nosotros" },
    { label: "Sucursales", to: "/sucursales" },
    { label: "Financiamiento", to: "/financiamiento" },
    { label: "Repuestos", to: "/repuestos" },
    { label: "Garantía", to: "/garantia" },
  ];

  return (
    <>
      {/* Móvil: header dedicado */}
      <MobileHeader />

      {/* Desktop: header flotante */}
      <header className="fixed inset-x-0 top-6 z-50 hidden w-full lg:top-8 lg:block">
        <div
          className={`relative mx-8 overflow-visible transition-all duration-300 ease-out xl:mx-auto xl:max-w-7xl ${
            isScrolled || forceScrolled
              ? "w-full rounded-2xl bg-[#1F2240]/90 shadow-[0_20px_60px_rgba(0,0,0,0.25)] backdrop-blur-xl"
              : ""
          }`}
        >
          {!isScrolled && !forceScrolled && (
            <div className="pointer-events-none absolute left-1/2 top-0 h-full w-[220px] -translate-x-1/2 bg-linear-to-b from-[#E10F18]/14 to-transparent blur-2xl" />
          )}
          <div className="flex h-24 w-full items-center justify-between gap-4 overflow-visible px-8">
            <div className="grid w-full grid-cols-[1fr_auto_1fr] items-center gap-4">
              <div className="flex min-w-0 items-center justify-self-start">
                <Link
                  to="/"
                  className="relative -my-5 block transition-transform hover:scale-[1.03] xl:-my-6"
                  aria-label="Inicio Oriental Ramirez"
                >
                  <span className="relative flex h-24 w-24 items-center justify-center rounded-full bg-white p-1.5 shadow-[0_12px_40px_rgba(225,15,24,0.28)] ring-4 ring-[#E10F18]/25 xl:h-28 xl:w-28">
                    <img
                      src="/logo.png"
                      alt=""
                      className="h-full w-full rounded-full object-cover"
                    />
                  </span>
                </Link>
              </div>

              <div className="flex justify-center justify-self-center">
                <HeaderNavPill
                  items={navItems}
                  isBar={isScrolled || forceScrolled}
                  lightText={lightText}
                />
              </div>

              <div className="flex items-center justify-end justify-self-end gap-2">
                <HeaderActionsPill />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
